import { InjectionToken } from '@angular/core';
import { AppConfig } from './config.model';

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
